// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#hotel-content
/*всё поле*/ {
  margin-left: 2vw;
  margin-right: 2vw;
  display: grid;
  padding: 0.2% 0.6% 0.3%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-height: 100vh;
  width: auto;
}
.hotel-conteiner {
  display: grid;
  grid-template-rows: auto auto 1fr;
  align-items: start;
  height: 100%;
    width: 100%;
  min-width: 0;
}

.hotel-mainsubtitle {
font-family: "Amatic SC";
    font-size: 3vw;
    text-align: center;
    margin-top: 0;
    width: 58vw;
}

.hotel-Logo-name {
  display: grid;
  grid-template-columns: 10vw 63vw 21.8vw;
  height: 3.8vw;
  z-index: 1;
}
.hotel-logo {
  height: 3.4vw;
  place-items: start;
}
.hotel-fullscreen {
      display: grid;
    height: 1.5vw;
    justify-self: end;
    position: relative;
}
.buttonCheck{
  display: grid;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Stevehotel/styles/HotelApp.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,yDAAgE;EAChE;;oCAEkC;EAClC,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;IACV,WAAW;EACb,YAAY;AACd;;AAEA;AACA,wBAAwB;IACpB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;MACM,aAAa;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;AACA;EACE,aAAa;AACf","sourcesContent":["#hotel-content\n/*всё поле*/ {\n  margin-left: 2vw;\n  margin-right: 2vw;\n  display: grid;\n  padding: 0.2% 0.6% 0.3%;\n  background-image: url(../../../../public/img/dust_scratches.png);\n  box-shadow:\n    0 4px 8px 0 rgba(0, 0, 0, 0.2),\n    0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  min-height: 100vh;\n  width: auto;\n}\n.hotel-conteiner {\n  display: grid;\n  grid-template-rows: auto auto 1fr;\n  align-items: start;\n  height: 100%;\n    width: 100%;\n  min-width: 0;\n}\n\n.hotel-mainsubtitle {\nfont-family: \"Amatic SC\";\n    font-size: 3vw;\n    text-align: center;\n    margin-top: 0;\n    width: 58vw;\n}\n\n.hotel-Logo-name {\n  display: grid;\n  grid-template-columns: 10vw 63vw 21.8vw;\n  height: 3.8vw;\n  z-index: 1;\n}\n.hotel-logo {\n  height: 3.4vw;\n  place-items: start;\n}\n.hotel-fullscreen {\n      display: grid;\n    height: 1.5vw;\n    justify-self: end;\n    position: relative;\n}\n.buttonCheck{\n  display: grid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
